export default function changeOpacityDomUtil ({ element, opacity }) {
  if (!element) {
    return
  }

  element.style.opacity = opacity
}
